<template>
	<div>
		<incomplete-forms
			:bookings="bookings"
			:incompleteForms="incompleteForms"
		/>
		<v-card>
			<v-data-table
				:headers="computedHeaders"
				:items="bookings"
				:items-per-page="100"
				:hide-default-header="$vuetify.breakpoint.xsOnly"
				item-key="row_identifier"
				class="elevation-1"
				hide-sort
				no-data-text="There is no data to this filters."
				:single-expand="true"
				:expanded.sync="expanded"
				show-expand:search="search"
				@click:row="clicked"
			>
				<template v-slot:[`item.residence_tax_amount`]="{ item }">
					{{ new Intl.NumberFormat(
						'de-DE',
						{ style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
						.format(Number(item.residence_tax_amount))
					}}
				</template>
				<template v-slot:expanded-item="current">
					<td :colspan="headers.length + 1" class="detailInfo">
						<registration-report-table-detail
							:key="updateKey"
							:detailRowsInfoAndData="detailRowsInfoAndData"
						/>
					</td>
				</template>
			</v-data-table>
		</v-card>
		<button-to-top-of-page/>
	</div>
</template>

<script>
import axios from 'axios'
import incompleteForms from './IncompleteFormList.vue'
import RegistrationReportTableDetail from './RegistrationReportTableDetail.vue'
import ButtonToTopOfPage from '../../vueBasics/ButtonToTopOfPage.vue'

export default {
	name: 'RegistrationReportTable',
	components: {
		incompleteForms,
		ButtonToTopOfPage,
		RegistrationReportTableDetail,
	},
	props: {
		bookings: {},
		selectedFilters: {},
		incompleteForms: {},

	},
	data() {
		return {
			headers: [
				{
					text: 'Serviceprovider',
					value: 'serviceprovider_name',
					selected: false,
					hide: true,
				},
				{
					text: "Serviceprovider's city",
					value: 'serviceprovider_city_zip',
					selected: false,
					hide: true,
				},
				{
					text: "Serviceprovider's Accommodation Type",
					value: 'serviceprovider_accommodation_type',
					selected: false,
					hide: true,
				},
				{
					text: 'Country of residence',
					value: 'country',
					selected: false,
					hide: false,
				},
				{
					text: 'Nationality',
					value: 'nationality_hesta',
					selected: false,
					hide: false,
				},
				{
					text: 'Nationality',
					value: 'nationality_iso',
					selected: false,
					hide: false,
				},
				{
					text: 'Canton',
					value: 'kanton',
					selected: false,
					hide: true,
				},
				{
					text: 'Status',
					value: 'registration_status',
					selected: false,
					hide: false,
				},
				{
					text: 'Reseller Partner',
					value: 'reseller_partner_name',
					selected: false,
					hide: false,
				},
				{
					text: 'Reseller User',
					value: 'reseller_user_name',
					selected: false,
					hide: false,
				},
				{
					text: 'Arrival by',
					value: 'arrival_by',
					selected: false,
					hide: false,
				},
				{
					text: 'Total number of issued guest cards',
					value: 'guestcard_total',
					selected: true,
					hide: true,
				},
				{
					text: 'Total number of guest',
					value: 'number_of_guests',
					selected: true,
					hide: true,
				},
				{
					text: 'Total number of registration forms',
					value: 'count_of_forms',
					selected: true,
					hide: true,
				},
				{
					text: 'Total number of overnight stays',
					value: 'overnight_total',
					selected: true,
					hide: false,
				},
				{
					text: 'Number of overnight stays adults',
					value: 'overnight_adult_total',
					selected: true,
					hide: false,
				},
				{
					text: 'Number of overnight stays 12-16 yrs.',
					value: 'overnight_adolescent_total',
					selected: true,
					hide: false,
				},
				{
					text: 'Number of overnight stays 0-12 yrs.',
					value: 'overnight_kid_total',
					selected: true,
					hide: false,
				},
				{
					text: 'Total sum visitor tax',
					value: 'residence_tax_amount',
					selected: true,
					hide: false,
				} /* Kurtaxe */,
			],
			expanded: [],
			detailRowsInfoAndData: [],
			updateKey: 0,
		}
	},
	watch: {
		expanded: {
			async handler() {
				const expandedRow = await this.expanded[0]
				this.getRowdetail(expandedRow).catch() // this is not an error on catch
			},
		},
		bookings: {
			handler() {
				this.expanded = []
			},
		},
	},
	computed: {
		computedHeaders() {
			try {
				this.headers.forEach((header) => {
					if (
						(header.value === 'country' && this.selectedFilters.country.length < 1)
						|| (header.value === 'nationality_hesta' && this.selectedFilters.nationality.length < 1)
						|| (header.value === 'serviceprovider_name' && this.selectedFilters.serviceprovider.length < 1)
						// eslint-disable-next-line max-len
						|| (header.value === 'serviceprovider_city_zip' && this.selectedFilters.serviceproviderCity.length < 1)
						// eslint-disable-next-line max-len
						|| (header.value === 'serviceprovider_accommodation_type' && this.selectedFilters.serviceproviderAccommodationType.length < 1)
						|| (header.value === 'kanton' && this.selectedFilters.kantons.length < 1)
						|| (header.value === 'registration_status' && this.selectedFilters.status.length < 1)
						|| (header.value === 'reseller_partner_name' && this.selectedFilters.resellerPartner.length < 1)
						|| (header.value === 'reseller_user_name' && this.selectedFilters.resellerUser.length < 1)
						|| (header.value === 'arrival_by' && this.selectedFilters.arrivalBy.length < 1)
						|| (header.value === 'nationality_iso' && this.selectedFilters.nationalityIso.length < 1)
					) {
						header.hide = true
					} else {
						header.hide = false
					}
					// Set header for aletsch - adolescent
					if (
						this.selectedFilters.mandator
						&& this.selectedFilters.mandator[0].value === 7
						&& header.value === 'overnight_adolescent_total.days'
					) {
						header.text = 'Number of overnight stays 6 - 16 yrs.'
					}
					// Set header for aletsch - kids
					if (
						this.selectedFilters.mandator
						&& this.selectedFilters.mandator[0].value === 7
						&& header.value === 'overnight_kid_total.days'
					) {
						header.text = 'Number of overnight stays 0 - 5 yrs.'
					}
				})
			} catch (e) {
				console.log('computedHeaders issue', e)
			}
			return this.headers.filter((h) => !h.hide)
		},
	},
	methods: {
		async clicked(value) {
			this.expanded.push(value)
			if (this.expanded[0] === this.expanded[1]) {
				this.expanded = []
			} else {
				this.expanded = []
				this.expanded.push(value)
			}
		},
		async getRowdetail(expandedRow) {
			if (this.expanded === []) return
			// eslint-disable-next-line max-len, no-undef
			const resDetail = await axios.post(`${config.baseAPIurl}/registration-report/row-detail`, {
				rowIdentifier: expandedRow.row_identifier,
				mandator: this.selectedFilters.mandator,
				dateFrom: this.selectedFilters.dateFrom,
				dateTill: this.selectedFilters.dateTill,
				country: this.selectedFilters.country,
				nationality: this.selectedFilters.nationality,
				serviceprovider: this.selectedFilters.serviceprovider,
				taxexemption: this.selectedFilters.taxexemption,
				kantons: this.selectedFilters.kantons,
				status: this.selectedFilters.status,
				serviceproviderCity: this.selectedFilters.serviceproviderCity,
				serviceproviderAccommodationType: this.selectedFilters.serviceproviderAccommodationType,
				resellerPartner: this.selectedFilters.resellerPartner,
				resellerUser: this.selectedFilters.resellerUser,
				arrivalBy: this.selectedFilters.arrivalBy,
				checkInDates: this.selectedFilters.checkInDates,
				checkOutDates: this.selectedFilters.checkOutDates,
				nationalityIso: this.selectedFilters.nationalityIso,
			})
			this.detailRowsInfoAndData = resDetail.data
			this.updateKey += 1
		},
	},
}
</script>

<style scoped>

.detailInfo {
	background-color: rgba(128, 128, 128, 0.2);
	padding: unset;
}

</style>
